// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__1_n2_","options":"AnswerScale_options__3lQdc","selected":"AnswerScale_selected__3MYiq"};